/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderSearchResult
 */
export interface ProviderSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    provider_type: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSearchResult
     */
    ccn?: string;
}

/**
 * Check if a given object implements the ProviderSearchResult interface.
 */
export function instanceOfProviderSearchResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "provider_type" in value;

    return isInstance;
}

export function ProviderSearchResultFromJSON(json: any): ProviderSearchResult {
    return ProviderSearchResultFromJSONTyped(json, false);
}

export function ProviderSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderSearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'provider_type': json['provider_type'],
        'address_line1': !exists(json, 'address_line1') ? undefined : json['address_line1'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'ccn': !exists(json, 'ccn') ? undefined : json['ccn'],
    };
}

export function ProviderSearchResultToJSON(value?: ProviderSearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'provider_type': value.provider_type,
        'address_line1': value.address_line1,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'phone': value.phone,
        'ccn': value.ccn,
    };
}

